import { isEmpty, includes } from 'lodash';

import { getURL } from '../api/Layers/layer-operations';

import adaptURL from './adapt-url';
import getCSVURLFromTMS from './get-csv-url-from-tms';
import getGeoJSONURLFromTMS from './get-geojson-url-from-tms';
import loadCSVTable from './load-csv-table';
import loadGeoJSONFromURL from './load-geojson-from-url';
import loadTMSBBoxFromURL from './load-tms-bbox-from-url';
import parseGeoJSONTable from './parse-geojson-table';

const GENERIC_DOMAIN = '/geoserver/gwc/service/tms/1.0.0/';
const COMING_SOON = 'ComingSoon';

/**
 * Fetches the TMS and returns the two arrays needed for the table.
 *
 * @async
 * @param {string} layer - The TMS layer.
 * @returns {object} An object containing the two arrays needed for the table.
 * @throws {Error} If something goes wrong.
 */
const loadTMSTable = async layer => {
  let tableTitle = [];
  let tableBody = [];
  const url = adaptURL(getURL(layer));
  if (!isEmpty(url) && includes(url, GENERIC_DOMAIN)) {
    try {
      const adaptedUrl = getCSVURLFromTMS(url);
      ({ tableBody, tableTitle } = await loadCSVTable({ url: adaptedUrl }));
    } catch (err) {
      if (includes(url, GENERIC_DOMAIN)) {
        try {
          const bbox = await loadTMSBBoxFromURL(url);
          const adaptedUrl = getGeoJSONURLFromTMS({ url, bbox });
          const geojson = await loadGeoJSONFromURL(adaptedUrl);
          ({ tableBody, tableTitle } = parseGeoJSONTable(geojson));
          return { tableBody, tableTitle };
        } catch (error) {
          if (includes(url, GENERIC_DOMAIN)) {
            tableTitle.push(COMING_SOON);
            return { tableBody, tableTitle };
          }
          throw new Error(err.message);
        }
      }
      throw new Error(err.message);
    }
  }
  return { tableBody, tableTitle };
};

export default loadTMSTable;
